import _ from 'lodash';
import types from 'frontend/state/actionTypes';

import talentSetReducer, { validName } from './talentSet';

const initialState = [];

const talentSetsReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case types.ADD_TALENT_SET:
      return [
        ...state,
        talentSetReducer(undefined, action),
      ];
    case types.DUPLICATE_TALENT_SET: {
      const duplicatedTalentSet = _.cloneDeep(_.find(state, { id: payload.talentSetId }));
      duplicatedTalentSet.id = payload.id;
      duplicatedTalentSet.name = '';
      return [
        ...state,
        duplicatedTalentSet,
      ];
    }
    case types.REMOVE_TALENT_SET:
      return _.reject(state, { id: payload });
    case types.LOAD_TALENTS_REPORT:
      return payload.meta.rawFormData.talentSets;
    case types.CHOOSE_TALENT:
    case types.INPUT_TALENT_SET_NAME:
      return state.map((talentSet) => {
        if (talentSet.id === payload.id) {
          return talentSetReducer(talentSet, action);
        }
        return talentSet;
      });
    case types.SUBMIT_SIM_SUCCESS:
      return initialState;
    default:
      return state;
  }
};

export default talentSetsReducer;

const talentSetsSelector = state => _.map(
  state.simbot.talentSets,
  talentSet => ({
    ...talentSet,
    validName: validName(talentSet),
  }),
);

export const selectors = {
  talentSets: talentSetsSelector,
};
